import { z } from 'zod';
import { LocalDateSchema } from './common';

export const ChallengeProgressStateSchema = z.enum(['locked', 'available', 'in_progress', 'completed']);
export type ChallengeProgressState = z.infer<typeof ChallengeProgressStateSchema>;

export const ChapterProgressStateSchema = z.enum(['locked', 'available', 'completed']);
export type ChapterProgressState = z.infer<typeof ChapterProgressStateSchema>;

export const LastAttemptSchema = z.object({
  passedCount: z.number().int().min(0),
  totalCount: z.number().int().min(0),
  at: z.iso.datetime({ offset: true }),
});
export type LastAttempt = z.infer<typeof LastAttemptSchema>;

export const ChapterProgressSchema = z.object({
  id: z.string(),
  slug: z.string(),
  state: ChapterProgressStateSchema,
  completed: z.number().int().min(0),
  total: z.number().int().min(0),
  bossUnlocked: z.boolean().optional(),
});
export type ChapterProgress = z.infer<typeof ChapterProgressSchema>;

export const ChallengeProgressSchema = z.object({
  id: z.string(),
  state: ChallengeProgressStateSchema,
  lastAttempt: LastAttemptSchema.optional(),
});
export type ChallengeProgress = z.infer<typeof ChallengeProgressSchema>;

export const ProgressResponseSchema = z.object({
  trackId: z.string(),
  chapters: z.array(ChapterProgressSchema),
  challenges: z.array(ChallengeProgressSchema),
  currentChallenge: z
    .object({ id: z.string(), chapterSlug: z.string(), challengeSlug: z.string() })
    .nullable(),
  totals: z.object({ completed: z.number().int().min(0), total: z.number().int().min(0) }),
  week: z.array(z.object({ date: LocalDateSchema, active: z.boolean() })).length(7),
});
export type ProgressResponse = z.infer<typeof ProgressResponseSchema>;
